import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { themeGet } from 'styled-system';
import { FastField } from 'formik';

import Box from '../Box';
import Text from '../Text';
import Option from '../Option';

import { Increment, Counter } from './Counter'

import getRandomID from '../utils/getRandomID';

const Table = styled(Box).attrs({ is: 'table' })`
  thead > tr > th,
  tbody > tr > td  {
    padding-top: 0.5em;
    padding-bottom: 0.5em;
  }
  thead > tr > th {
    border-bottom: 2px solid ${themeGet('colors.gray')};
  }

`;

class MatrixChoice extends PureComponent {
  constructor(props) {
    super(props);
    const { optionWidth, degrees } = props;
    this.randomID = getRandomID(6);
    this.optionWidth = optionWidth || (Math.max(...degrees.map((opt) => opt.length)) + 1.5) + 'em';
  }

  render() {
    const {
      label,
      dimensions,
      degrees,
      name,
      disabled,
      listType,
      randomID,
      required,
      value,
      onChange,
      onBlur,
      values,
      readOnly,
      ...props
    } = this.props;

    return (
      <Box {...props}>
        <Table width={1}>
          <thead>
            <tr>
              <th></th>
              {degrees.map((opt, index) => (
                <Box is="th" mx="0.5em" width={this.optionWidth} key={index}>
                  <Text>{opt}</Text>
                </Box>
              ))}
            </tr>
          </thead>
          <tbody>
            {dimensions.map((dim, dimIndex) => {
              const subName = `${name}-${dimIndex}`;
              return (
                <FastField key={dimIndex} name={subName}>
                  {({ form, field }) => (
                    <Increment is="tr" name={this.randomID} bg={dimIndex % 2 && 'variations.gray.0'}>
                      <Box is="td" px="1em">
                        <Counter type="upper-alpha" name={this.randomID}>{dim}</Counter>
                        {form.touched[field.name] && form.errors[field.name] && (
                          <Text.error>{form.errors[field.name]}</Text.error>
                        )}
                      </Box>
                      {degrees.map((opt, index) => (
                        <Box is="td" key={`${dimIndex}${index}`} textAlign="center" px="0.5em">
                          <Option
                            type="radio"
                            disabled={disabled}
                            checked={form.values[subName] === opt}
                            {...field}
                            value={opt}
                            readOnly={readOnly}
                          />
                        </Box>
                      ))}
                    </Increment>
                  )}
                </FastField>
              );
            })}
          </tbody>
        </Table>
      </Box>
    );
  }
}

MatrixChoice.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  dimensions: PropTypes.arrayOf(PropTypes.string,).isRequired,
  degrees: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  listType: PropTypes.string,
};

MatrixChoice.defaultProps = {
  listType: 'upper-alpha',
};

export default MatrixChoice;
